import './member-sign-in-form.scss'
import type { MemberSignInFormProps as OCCMemberSignInFormProps } from '@vista-digital/occ-ui'
import { MemberSignInFormComponent, MemberSignInFormFieldComponent } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import ButtonLink from '@/common/components/buttonLink/ButtonLink'
import type { MemberSignInFormPropsApi } from '@/common/components/signInForm/memberSignInForm/models'
import { useHasCaptcha } from '@/common/hooks/useHasCaptcha'
import {
    getCaptchFieldProps,
    getIdentifierFieldProps,
    getPasswordFieldProps,
    getRememberFieldProps,
    memberSignInFormProps,
} from './props'

export interface MemberSignInFormProps {
    displayText: MemberSignInFormPropsApi
    events?: OCCMemberSignInFormProps['events']
    onNavigateToForgotPassword?: () => void
}

export const MemberSignInForm: FC<MemberSignInFormProps> = props => {
    const { displayText, onNavigateToForgotPassword } = props
    const captchaEnabled = useHasCaptcha()

    return (
        <MemberSignInFormComponent {...memberSignInFormProps({ ...props, captchaEnabled })}>
            <MemberSignInFormFieldComponent {...getIdentifierFieldProps(displayText)} />
            <MemberSignInFormFieldComponent {...getPasswordFieldProps(displayText)} />
            <MemberSignInFormFieldComponent {...getRememberFieldProps(displayText)} />
            <ButtonLink
                label={displayText.forgotPasswordLabel}
                onClick={onNavigateToForgotPassword}
                className="go-back"
            />
            {captchaEnabled && <MemberSignInFormFieldComponent {...getCaptchFieldProps(displayText)} />}
        </MemberSignInFormComponent>
    )
}
